export const USER_REGISTER = "USER_REGISTER";
export const USER_LOGIN = "USER_LOGIN";